import { SearchMode, useSearch } from "~/core/composables/useSearch";
import LxcError from "~/core/models/LxcError.class";
import {
  Filters,
  type FiltersSelection,
  FiltersType,
  OPERATOR_RSQL_ILIKE,
} from "~/core/models/filters";
import filtersUtils from "~/core/utils/filters.utils";
import type { OrganizationV2 } from "~/modules/organization/models/OrganizationV2.interface";
import organizationService from "~/modules/organization/services/organization.service";

export function useOrganization(
  searchMode: SearchMode = SearchMode.URL_SEARCH,
) {
  const appliedFilters: FiltersSelection = new Map([
    [
      Filters.ORGANIZATION_NAME,
      {
        key: "name",
        operator: OPERATOR_RSQL_ILIKE,
        value: "",
        valueFormatter: filtersUtils.formatRSQLValue,
      },
    ],
  ]);

  const { searchParams, filters, setFilter, search, onSearch } = useSearch(
    FiltersType.RSQL,
    appliedFilters,
    searchMode,
  );

  const results: Ref<OrganizationV2[] | undefined> = ref();
  const isLoading: Ref<boolean> = ref(false);
  const error: Ref<LxcError | undefined> = ref();

  async function fetchData(businessUnitCode: number): Promise<void> {
    isLoading.value = true;
    const response = await organizationService.getOrganizations(
      businessUnitCode,
      searchParams.value,
    );
    if (LxcError.check(response)) {
      error.value = response;
    } else {
      results.value = response;
    }
    isLoading.value = false;
  }

  return {
    isLoading,
    results,
    error,
    filters,
    fetchData,
    setFilter,
    search,
    onSearch,
  };
}
